'use client';

import { VolumeHighIcon, VolumeSlashIcon } from '@insta-club/components';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface Props {
    isMuted: boolean;
}

const ToggleMutedBtn: React.FC<Props> = ({ isMuted }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        setVisible(true);
        const timeout = setTimeout(() => setVisible(false), 1000);
        return () => clearTimeout(timeout);
    }, [isMuted]);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0 }}
                    transition={{ duration: 0.2 }}
                    className='absolute-center flex h-14 w-14 items-center justify-center rounded-full bg-gray-950/50 text-white backdrop-blur-sm'
                >
                    {isMuted ? <VolumeSlashIcon /> : <VolumeHighIcon />}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ToggleMutedBtn;

